import { track, logError } from '@tracking';

import { getSearchAsObject } from '@shared/selectors';
import getShop from '@core/reducers/shop/selectors/getShop';
import getCountryCurrencyIsoCode from '@location/selectors/getCountryCurrencyIsoCode';
import getProduct from '@productConfig/selectors/getProduct';
import { QUERY_PARAM } from '@commons/constants';

import { EVENT_ORIGIN } from '../constants';

const getProductChoicesQuantity = product => {
  let result = {
    productMandatoryChoiceQuantity: 0,
    productOptionalChoiceQuantity: 0,
  };

  if (product && product.optionGroups) {
    result = product.optionGroups.reduce((acc, og) => {
      if (og.quantity !== 0) acc.productMandatoryChoiceQuantity += 1;
      else acc.productOptionalChoiceQuantity += 1;
      return acc;
    }, result);
  }

  return result;
};

const trackProductConfiguration = ({ quantity = 1, errorType = '' }) => (
  dispatch,
  getState,
) => {
  const EVENT_NAME = errorType
    ? 'product_choice.failed'
    : 'product_choice.opened';

  try {
    const state = getState();
    const shop = getShop(state);
    const search = getSearchAsObject(state);
    const product = getProduct(state);
    const currencyCode = getCountryCurrencyIsoCode(state);

    const eventOrigin =
      search &&
      (search[QUERY_PARAM.PRODUCT_CONFIG] ||
        search[QUERY_PARAM.FEATURED_PRODUCT_CONFIG])
        ? EVENT_ORIGIN.MENU
        : EVENT_ORIGIN.CART_MODIFY;

    const {
      productMandatoryChoiceQuantity,
      productOptionalChoiceQuantity,
    } = getProductChoicesQuantity(product);

    const payload = {
      shopId: shop?.id,
      shopName: shop?.name,
      productSku: product?.id,
      productName: product?.name,
      currencyCode,
      productQuantity: quantity,
      productCategory: product?.foodCategoryTag?.name,
      productVariant: null,
      productUnitSalePrice: product?.priceWithDiscount,
      productUnitPrice: product?.price,
      productMandatoryChoicePreselected: false,
      productMandatoryChoiceQuantity,
      productOptionalChoiceQuantity,
      eventOrigin,
    };

    if (errorType) payload.errorType = errorType;

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackProductConfiguration;
